import React from 'react';
import { IRifa } from '../../types/rifa';
import { convertDataSorteio } from '../../utils/FunctionUtils';
import Loading from '../../components/Loading';

interface Props {
	rifa: IRifa,
	loading?: boolean
}

const CapaRifaCancelada: React.FC<Props> = (props) => {
	const rifa = props.rifa;
	const currencyFormat = { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' }
	const valorUnitario = rifa.valorUnitario ? rifa.valorUnitario : 0;

	// Se a rifa não foi cancelada, é porque não atingiu a meta
	let rifaCancelada = rifa.motivoReprovacao ? true : false; 

   return (
		<section id="testimonials5-ny" className="mb-5">
			{/* Imagem de capa */}
			<div id="rifa-cover-img">
				{/* Descricao do status da rifa */}
				<div className="text-center pt-4">
					<h2 className="title-common title-secondary">
						A campanha está cancelada
					</h2>
				</div>
         </div>

			{/* Imagem do organizador */}
			<div className="d-flex">
			   <img src={`${process.env.PUBLIC_URL}/images/rifa-logo-150x150.png`}
					className="img-organizador"
					alt="Organizador da Campanha" />
			</div>

			{ props.loading ?
				<div className="mt-4">
					<Loading />
				</div>
				:
				<div className="text-center padding-x mt-2" style={{ lineHeight: "1.5", fontSize: "1.2rem" }}> 
					{/* Nome do beneficiário */}
					<div id="nome-beneficiado">
						{rifa.nomeBeneficiado}
					</div>

					{/* Valor da rifa */}
					<div>
						Valor da rifa: {valorUnitario.toLocaleString("pt-BR", currencyFormat)}
					</div>

					{/*Data da Rifa e Nome do Organizador */}
					<div>
						Data do sorteio: {rifa.dataEncerramento ? convertDataSorteio(rifa.dataEncerramento) : "00/00/0000"}
						<br />
						Organização: {rifa.nomeOrganizador}
					</div>

					{/* Motivo do cancelamento */}
					<div className="my-4 pb-4">
						<p>
							Motivo do cancelamento: {rifaCancelada ? rifa.motivoReprovacao : "meta não atingida."} Qualquer dúvida, entre em contato com o organizador.
						</p>

						<p>
							Se você fez uma doação para esta campanha, já foi solicitado à PagSeguro o estorno dos pagamentos. 
							Para compras realizadas com cartão de crédito, estorno é efetuado pela administradora de cartões como 
							um crédito na próxima fatura do comprador. O PagSeguro envia um e-mail de confirmação informando a 
							data que o crédito foi encaminhado para o banco emissor. O prazo para o crédito no seu cartão pode 
							variar conforme data de fechamento da sua fatura. 
						</p>

						<p>
							Para compras realizadas no boleto, estorno é efetuado em forma de crédito na conta PagSeguro ou vinculada 
							ao e-mail utilizado no ato da transação do comprador. É possível utilizar o saldo para uma nova compra 
							ou solicitar o saque do valor para sua conta bancária. Mais informações no tutorial da PagSeguro sobre 
							saque: 
								<a href="http://blogpagseguro.com.br/2012/03/tutorial-pagseguro-como-solicitar-saques/" 
									target="_blank" rel="noopener noreferrer">
									http://blogpagseguro.com.br/2012/03/tutorial-pagseguro-como-solicitar-saques/
								</a>
						</p>
					</div>
				</div>
			}
      </section>  
   );
}

export default CapaRifaCancelada;